import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VaIconModule } from '../../va-icon/icon.module';
import { VaMenuComponent } from './va-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    VaIconModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    GalaxyTooltipModule,
  ],
  declarations: [VaMenuComponent],
  exports: [VaMenuComponent],
})
export class VaMenuModule {}
